import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useUser } from "../hooks/useUser";
import Loader from "./Spinner.component";

function ProtectedAdmin({ children }) {
  const navigate = useNavigate();

  const { isLoading, isAdminAuthenticated } = useUser();

  useEffect(
    function () {
      if (!isAdminAuthenticated && !isLoading) navigate("/login");
    },
    [isAdminAuthenticated, isLoading, navigate]
  );

  if (isLoading) return <Loader />;

  if (isAdminAuthenticated) return children;
}

export default ProtectedAdmin;
